import ClubListItem from "app/components/ClubListItem";
import Flex from "app/components/UI/Flex";
import ImmutablePropTypes from "react-immutable-proptypes";
import PropTypes from "prop-types";
import React from "react";
import classes from "./ClubList.module.css";

export const ClubList = ({ orderedClubs, onChangeClub, currentPosition }) => (
  <Flex direction="row" wrap className={classes.clubList}>
    {orderedClubs.map(club => (
      <ClubListItem key={club.get("@id")} club={club} onChangeClub={onChangeClub} currentPosition={currentPosition} />
    ))}
  </Flex>
);

ClubList.propTypes = {
  orderedClubs: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired,
  onChangeClub: PropTypes.func.isRequired,
  currentPosition: PropTypes.object
};

export default ClubList;



// WEBPACK FOOTER //
// ./src/app/components/ClubList/ClubList.js